module.exports = __webpack_public_path__ + "static/img/sjThree.e609b80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sjThree.jpg
// module id = T8Yx
// module chunks = 1